import { problems, solutions, siteConfig } from '@/mocks/data';

export default function ProblemSolutionSection() {
  const whatsappHref = `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent('Merhaba, Atak Sistem Enerji ısıtma sistemleri hakkında bilgi almak istiyorum.')}`;

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-4">
            Yakıt Giderleri Yükselirken Akıllı Isıtmaya Geçin
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            Kömür, soba, yüksek yakıt maliyeti ve zahmetli ısınma süreçleri yerine; Fineco Isı Pompası ile modern, konforlu ve verimli bir çözüm tercih edebilirsiniz.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
          <div className="bg-accent-50 rounded-lg p-6 md:p-8 border border-accent-100">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 rounded-full bg-accent-500 flex items-center justify-center">
                <i className="ri-close-line text-background-50 text-lg w-5 h-5 flex items-center justify-center"></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900">Mevcut Isınma Zorlukları</h3>
            </div>
            <div className="flex flex-col gap-3">
              {problems.map((problem) => (
                <div
                  key={problem.id}
                  className="flex items-center gap-3 bg-background-50 rounded-md p-3 border border-accent-100/50"
                >
                  <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center shrink-0">
                    <i className={`${problem.icon} text-accent-600 w-4 h-4 flex items-center justify-center`}></i>
                  </div>
                  <span className="text-sm text-foreground-700 font-medium">{problem.text}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-primary-50 rounded-lg p-6 md:p-8 border border-primary-100">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-check-line text-background-50 text-lg w-5 h-5 flex items-center justify-center"></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900">Fineco Isı Pompası Çözümleri</h3>
            </div>
            <div className="flex flex-col gap-3">
              {solutions.map((solution) => (
                <div
                  key={solution.id}
                  className="flex items-center gap-3 bg-background-50 rounded-md p-3 border border-primary-100/50"
                >
                  <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                    <i className={`${solution.icon} text-primary-600 w-4 h-4 flex items-center justify-center`}></i>
                  </div>
                  <span className="text-sm text-foreground-700 font-medium">{solution.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="flex justify-center mt-8">
          <a
            href={whatsappHref}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-3 rounded-md text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-whatsapp-line w-5 h-5 flex items-center justify-center"></i>
            Hemen Bilgi Al
          </a>
        </div>
      </div>
    </section>
  );
}